module.exports = __webpack_public_path__ + "static/home_04_mobile-9e85eb6d0a1e593ae7dd72b3a2935eda.webp";